import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getMetricSliceContent = createAsyncThunk('/metrics/content', async () => {
	const response = await axios.post(`${API_URL}/getMetrics`);
    console.log(response.data);
	return response;
})

export const metricSlice = createSlice({
    name: 'metrics',
    initialState: {
        isLoading: false,
        metrics : []
    },
    reducers: {
    },
    extraReducers: {
		[getMetricSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getMetricSliceContent.fulfilled]: (state, action) => {
			state.metrics = action.payload.data
			state.isLoading = false
		},
		[getMetricSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default metricSlice.reducer